import {InjectionToken} from '@angular/core';

export const IS_WEB_COMPONENT = new InjectionToken<boolean>('IsWebComponent');
